<template>
    <liveroom-module
        v-if="classId"
        :class-id="classId"
        :sub-id="subId"
        :is-replay="isReplay"
        @live-info="getLiveInfo"
    ></liveroom-module>
</template>
<script>
import Vue from 'vue'
import $ from 'jquery'
import Message from 'lingdongliang-module/lib/Message'
import OpenApp from 'lingdongliang-module/lib/OpenApp'
import 'lingdongliang-module/lib/theme_package/OpenApp.css'
import { LiveroomModule, SMSLogin } from 'lingdongliang-module'
import fullscreen from 'vue-fullscreen'

Vue.use(LiveroomModule)
Vue.use(SMSLogin)
Vue.use(Message)
Vue.use(fullscreen)

export default {
  name: 'LiveRoom',
  data () {
    return {
      classId: 0,
      subId: 0,
      isReplay: false,
      isMobileStyle: document.body.clientWidth < 768
    }
  },
  mounted () {
    this.classId = Number(this.$route.params.classId)
    this.subId = Number(this.$route.params.subId)
    this.isReplay = this.$route.params.action === 'replay'
  },
  methods: {
    track: function ({ node, props }) {
      this.zhuGeEventTrack(node, props)
    },
    getLiveInfo (liveInfo) {
      const params = {
        websiteOwnership: 'ldl',
        openParams: {
          classId: this.classId,
          subclassId: this.subId,
          isLive: !this.isReplay,
          price: Number(liveInfo.price),
          deadline_at: liveInfo.deadline_at
        },
        openType: 'live',
        track: this.track
      }
      if (this.isMobileStyle) {
        OpenApp.createArouseApp(params)
      }
    }
  },
  destroyed () {
    if (this.isMobileStyle) {
      OpenApp.removeArouseApp()
    }
    $(window).off('scroll', this.scrollFunc)
  }
}
</script>
<style lang="scss">
@media (min-width: 300px) and (max-width: 767px) {
  .container{
    padding: 0;
    margin-top: 0!important;
  }
}
.gift-wrap input{
    margin-top: 0;
}
</style>
